export enum ProgramType {
    Live = 1,
    ArchiveVideo = 3,
    Tv = 6
}